<div class="modal-body" data-automation-id="persistentCartModal">
  <div class="col d-flex justify-content-end">
    <button
      type="button"
      class="btn-close btn-close-red"
      data-automation-id="persistentCartXButton"
      aria-label="Close"
      (click)="dismiss()"
    ></button>
  </div>

  <div *ngIf="cart.items.length > 0; then fullcart; else emptycart"></div>

  <ng-template #emptycart>
    <h4
      class="col d-flex justify-content-center mt-8 mb-10"
      data-automation-id="clearedCartMessage"
    >
      Your cart has been cleared.
    </h4>
  </ng-template>

  <ng-template #fullcart>
    <h4
      class="col d-flex justify-content-center my-8 text-center"
      [innerHtml]="title"
    ></h4>

    <div
      class="col margin-m d-flex justify-content-center align-items-center"
      data-automation-id="persistentCartProductCardName"
      *ngFor="let item of cart.items"
    >
      <div class="d-flex justify-content-end align-items-center w-auto">
        <img
          alt="{{ item.name }}"
          data-automation-id="persistentCartProductImage"
          class="product-image"
          [src]="item.imageUrl"
          *ngIf="item.imageUrl"
        />
      </div>

      <p class="m-0 w-auto px-5">
        <strong>{{ item.name }}</strong>
      </p>
    </div>

    <digital-platform-cta-button
      class="col d-flex justify-content-center margin-m my-8"
      data-automation-id="persistentCartCheckoutButton"
      [ctaSize]="createCMSObject('ctaSize', 'button__lg')"
      [ctaStyle]="createCMSObject('ctaStyle', 'btn-primary')"
      (click)="checkout()"
      ><digital-platform-icon
        class="check-icon"
        icon="check-circle-solid"
        color="secondary"
        [height]="24"
        [width]="24"
      ></digital-platform-icon>
      <div class="pseudo-icon-fill"></div>
      Check out</digital-platform-cta-button
    >

    <digital-platform-rsx-a
      class="col d-flex justify-content-center custom-rsx-a-style margin-m"
      data-automation-id="clearCartLink"
      styling="color: var(--bs-red); text-decoration: none;"
      (click)="clearCart()"
      ><strong>Clear items from cart</strong></digital-platform-rsx-a
    >
  </ng-template>
</div>
